import {
  ARCHIVE_LAYERS_EXPANDED_SET,
  BACKGROUND_LAYERS_EXPANDED_SET,
  CLOSE_OBJECT_DETAILS_WINDOW,
  COMPOSITION_LAYERS_EXPANDED_SET,
  DISPLAY_CLOSEST_OBJECT_INFO,
  FEATURES_TABLE_ACTIVE_TAB_SET,
  MAP_ZOOM_MODE_TOGGLE, MVT_LAYERS_EXPANDED_SET,
  PWID_LAYERS_EXPANDED_SET,
  REPORT_DEMAND_POPUP_HIDE,
  REPORT_DEMAND_POPUP_SHOW,
  SET_APPLIED_FILTERS,
  SYSTEM_LAYERS_EXPANDED_SET,
  USER_LAYERS_EXPANDED_SET,
  WINDOW_ADD_LAYER_FROM_SERVICE_HIDE,
  WINDOW_ADD_LAYER_FROM_SERVICE_SHOW,
  WINDOW_API_ERROR_HIDE,
  WINDOW_API_ERROR_SHOW,
  WINDOW_ASK_FOR_ARCHIVE_DATA_HIDE,
  WINDOW_ASK_FOR_ARCHIVE_DATA_SHOW,
  WINDOW_DEMAND_EXPORT_HIDE,
  WINDOW_DEMAND_EXPORT_SHOW,
  WINDOW_DEMAND_FORM_HIDE,
  WINDOW_DEMAND_FORM_SHOW,
  WINDOW_DOWNLOAD_TEMPLATE_HIDE,
  WINDOW_DOWNLOAD_TEMPLATE_SHOW,
  WINDOW_EXPORT_TO_FILE_HIDE,
  WINDOW_EXPORT_TO_FILE_SHOW,
  WINDOW_FEATURES_FILTER_HIDE,
  WINDOW_FEATURES_FILTER_SHOW,
  WINDOW_FEATURES_TABLE_COLUMNS_HIDE,
  WINDOW_FEATURES_TABLE_COLUMNS_SHOW,
  WINDOW_FIELDS_CALCULATOR_HIDE,
  WINDOW_FIELDS_CALCULATOR_SHOW,
  WINDOW_GET_LAYER_FROM_FILE_HIDE,
  WINDOW_GET_LAYER_FROM_FILE_SHOW,
  WINDOW_HISTORY_DETAILS_HIDE,
  WINDOW_HISTORY_DETAILS_SHOW,
  WINDOW_HISTORY_FILTER_HIDE,
  WINDOW_HISTORY_FILTER_SHOW,
  WINDOW_MAP_PERMALINK_MODAL_HIDE,
  WINDOW_MAP_PERMALINK_MODAL_SHOW,
  WINDOW_MAP_SHORTCUTS_HIDE,
  WINDOW_MAP_SHORTCUTS_SHOW,
  WINDOW_MIGRATION_ERROR_HIDE,
  WINDOW_MIGRATION_ERROR_SHOW,
  WINDOW_NOTIFICATION_HIDE,
  WINDOW_NOTIFICATION_SHOW,
  WINDOW_REPORT_WIZARD_HIDE,
  WINDOW_REPORT_WIZARD_SHOW,
  WINDOW_SAVE_COMPOSITION_HIDE,
  WINDOW_SAVE_COMPOSITION_SHOW,
  WINDOW_SEARCH_RESULT_FILTER_HIDE,
  WINDOW_SEARCH_RESULT_FILTER_SHOW,
  WINDOW_SET_CENTRE_HIDE,
  WINDOW_SET_CENTRE_SHOW,
  WINDOW_ZOOM_TO_OWN_RANGE_HIDE,
  WINDOW_ZOOM_TO_OWN_RANGE_SHOW
} from './mutations.type';

const initialState = {
  appliedSearchResultFilters: {},
  centreWindowVisible: false,
  reportDemandPopupVisible: false,
  reportDemandPopupAddress: null,
  demandFormVisible: false,
  demandExportVisible: false,
  mapPermalinksVisible: false,
  searchResultFilterVisible: false,
  demandForm: null,
  distinctColumnValues: {},
  saveCompositionWindowVisible: false,
  apiErrorWindowVisible: false,
  apiErrorMessage: '',
  migrationErrorWindowVisible: false,
  migrationErrorMessage: {
    status: '',
    error: '',
    errorFilePath: ''
  },
  getLayerFromFileWindowVisible: false,
  addLayerFromServiceWindowVisible: false,
  showMapShortcutsWindowVisible: false,
  downloadTemplateWindowVisible: false,
  notification: {
    type: 'success',
    message: 'Operacja zakończona powodzeniem.',
    title: 'Sukces!',
    duration: 2000,
    ignoreDuplicates: false
  },
  featuresTableColumnsWindowVisible: false,
  featuresFilterWindowVisible: false,
  historyFilterWindowVisible: false,
  historyDetailsWindowVisible: false,
  reportWizardWindowVisible: false,
  exportToFileWindowVisible: false,
  askForArchiveDataWindowVisible: false,
  zoomToOwnRangeWindowVisible: false,
  fieldsCalculatorWindowVisible: false,
  featuresTableActiveTab: null,
  layersTabExpanded: {
    system: true,
    user: false,
    custom: false,
    composition: false,
    background: false,
    mvt: false,
    pwid: false
  },
  objectDetailsWindowVisible: false,
  zoomMode: false,
  closestObjectInfo: null
};
const ATTRIBUTES_TAB = 'ATTRIBUTES';
const HISTORY_TAB = 'HISTORY';

export const state = Object.assign({}, initialState);

export const mutations = {
  [REPORT_DEMAND_POPUP_SHOW](state, address) {
    state.reportDemandPopupAddress = address;
    state.reportDemandPopupVisible = true;
  },
  [REPORT_DEMAND_POPUP_HIDE](state) {
    state.reportDemandPopupVisible = false;
  },
  [WINDOW_SET_CENTRE_SHOW](state) {
    state.centreWindowVisible = true;
  },
  [WINDOW_SET_CENTRE_HIDE](state) {
    state.centreWindowVisible = false;
  },
  [WINDOW_SAVE_COMPOSITION_SHOW](state) {
    state.saveCompositionWindowVisible = true;
  },
  [WINDOW_SAVE_COMPOSITION_HIDE](state) {
    state.saveCompositionWindowVisible = false;
  },
  [WINDOW_API_ERROR_SHOW](state, error) {
    state.apiErrorMessage = error;
    state.apiErrorWindowVisible = true;
  },
  [WINDOW_API_ERROR_HIDE](state) {
    state.apiErrorWindowVisible = false;
  },
  [WINDOW_MIGRATION_ERROR_SHOW](state, data) {
    state.migrationErrorMessage = data;
    state.migrationErrorWindowVisible = true;
  },
  [WINDOW_MIGRATION_ERROR_HIDE](state) {
    state.migrationErrorWindowVisible = false;
  },
  [WINDOW_GET_LAYER_FROM_FILE_SHOW](state) {
    state.getLayerFromFileWindowVisible = true;
  },
  [WINDOW_GET_LAYER_FROM_FILE_HIDE](state) {
    state.getLayerFromFileWindowVisible = false;
  },
  [WINDOW_ADD_LAYER_FROM_SERVICE_SHOW](state) {
    state.addLayerFromServiceWindowVisible = true;
  },
  [WINDOW_ADD_LAYER_FROM_SERVICE_HIDE](state) {
    state.addLayerFromServiceWindowVisible = false;
  },
  [WINDOW_MAP_SHORTCUTS_SHOW](state) {
    state.showMapShortcutsWindowVisible = true;
  },
  [WINDOW_MAP_SHORTCUTS_HIDE](state) {
    state.showMapShortcutsWindowVisible = false;
  },
  [WINDOW_DOWNLOAD_TEMPLATE_SHOW](state) {
    state.downloadTemplateWindowVisible = true;
  },
  [WINDOW_DOWNLOAD_TEMPLATE_HIDE](state) {
    state.downloadTemplateWindowVisible = false;
  },
  [WINDOW_NOTIFICATION_SHOW](state, config) {
    state.notification.message = config.message;
    state.notification.type = config.type || 'success';
    state.notification.title = config.title || 'Sukces!';
    state.notification.timeout = config.duration || 5000;
    state.notification.duration = config.changedDuration;
    state.notification.ignoreDuplicates = config.ignoreDuplicates;
  },
  [WINDOW_NOTIFICATION_HIDE](state) {
    state.notification.message = '';
  },
  [WINDOW_FEATURES_TABLE_COLUMNS_SHOW](state) {
    state.featuresTableColumnsWindowVisible = true;
  },
  [WINDOW_FEATURES_TABLE_COLUMNS_HIDE](state) {
    state.featuresTableColumnsWindowVisible = false;
  },
  [WINDOW_FEATURES_FILTER_SHOW](state) {
    state.featuresFilterWindowVisible = true;
  },
  [WINDOW_FEATURES_FILTER_HIDE](state) {
    state.featuresFilterWindowVisible = false;
  },
  [WINDOW_HISTORY_FILTER_SHOW](state) {
    state.historyFilterWindowVisible = true;
  },
  [WINDOW_HISTORY_FILTER_HIDE](state) {
    state.historyFilterWindowVisible = false;
  },
  [WINDOW_HISTORY_DETAILS_SHOW](state) {
    state.historyDetailsWindowVisible = true;
  },
  [WINDOW_HISTORY_DETAILS_HIDE](state) {
    state.historyDetailsWindowVisible = false;
  },
  [WINDOW_REPORT_WIZARD_SHOW](state) {
    state.reportWizardWindowVisible = true;
  },
  [WINDOW_REPORT_WIZARD_HIDE](state) {
    state.reportWizardWindowVisible = false;
  },
  [WINDOW_EXPORT_TO_FILE_SHOW](state) {
    state.exportToFileWindowVisible = true;
  },
  [WINDOW_EXPORT_TO_FILE_HIDE](state) {
    state.exportToFileWindowVisible = false;
  },
  [WINDOW_ASK_FOR_ARCHIVE_DATA_SHOW](state) {
    state.askForArchiveDataWindowVisible = true;
  },
  [WINDOW_ASK_FOR_ARCHIVE_DATA_HIDE](state) {
    state.askForArchiveDataWindowVisible = false;
  },
  [WINDOW_ZOOM_TO_OWN_RANGE_SHOW](state) {
    state.zoomToOwnRangeWindowVisible = true;
  },
  [WINDOW_ZOOM_TO_OWN_RANGE_HIDE](state) {
    state.zoomToOwnRangeWindowVisible = false;
  },
  [WINDOW_FIELDS_CALCULATOR_SHOW](state) {
    state.fieldsCalculatorWindowVisible = true;
  },
  [WINDOW_FIELDS_CALCULATOR_HIDE](state) {
    state.fieldsCalculatorWindowVisible = false;
  },
  [WINDOW_DEMAND_FORM_SHOW](state, payload) {
    state.demandFormVisible = true;
    state.demandForm = payload;
  },
  [WINDOW_DEMAND_FORM_HIDE](state) {
    state.demandFormVisible = false;
  },
  [WINDOW_SEARCH_RESULT_FILTER_SHOW](state, payload) {
    state.searchResultFilterVisible = true;
    state.distinctColumnValues = payload;
  },
  [WINDOW_SEARCH_RESULT_FILTER_HIDE](state) {
    state.searchResultFilterVisible = false;
  },
  [WINDOW_DEMAND_EXPORT_SHOW](state) {
    state.demandExportVisible = true;
  },
  [WINDOW_DEMAND_EXPORT_HIDE](state) {
    state.demandExportVisible = false;
  },
  [WINDOW_MAP_PERMALINK_MODAL_SHOW](state) {
    state.mapPermalinksVisible = true;
  },
  [WINDOW_MAP_PERMALINK_MODAL_HIDE](state) {
    state.mapPermalinksVisible = false;
  },
  [WINDOW_FEATURES_TABLE_COLUMNS_HIDE](state) {
    state.featuresTableColumnsWindowVisible = false;
  },
  [FEATURES_TABLE_ACTIVE_TAB_SET](state, payload) {
    if (payload.historyTab) {
      state.featuresTableActiveTab = HISTORY_TAB;
    }
    if (payload.attrTab) {
      state.featuresTableActiveTab = ATTRIBUTES_TAB;
    }
  },
  [SYSTEM_LAYERS_EXPANDED_SET](state, value) {
    setLayersTabExpanded(state, 'system', value);
  },
  [MVT_LAYERS_EXPANDED_SET](state, value) {
    setLayersTabExpanded(state, 'mvt', value);
  },
  [PWID_LAYERS_EXPANDED_SET](state, value) {
    setLayersTabExpanded(state, 'PWID', value);
  },
  [ARCHIVE_LAYERS_EXPANDED_SET](state, value) {
    setLayersTabExpanded(state, 'archive', value);
  },
  [USER_LAYERS_EXPANDED_SET](state, value) {
    setLayersTabExpanded(state, 'user', value);
  },
  [COMPOSITION_LAYERS_EXPANDED_SET](state, value) {
    setLayersTabExpanded(state, 'composition', value);
  },
  [BACKGROUND_LAYERS_EXPANDED_SET](state, value) {
    setLayersTabExpanded(state, 'background', value);
  },
  [SET_APPLIED_FILTERS](state, newFilters) {
    state.appliedSearchResultFilters = { ...newFilters };
  },
  [DISPLAY_CLOSEST_OBJECT_INFO](state, closestObject) {
    state.closestObjectInfo = closestObject;
    state.objectDetailsWindowVisible = true;
  },
  [CLOSE_OBJECT_DETAILS_WINDOW](state) {
    state.objectDetailsWindowVisible = false;
  },
  [MAP_ZOOM_MODE_TOGGLE](state) {
    state.zoomMode = !state.zoomMode;
  }
};

function setLayersTabExpanded(state, tabKey, extend) {
  if (extend) {
    for (const key of Object.keys(state.layersTabExpanded)) {
      state.layersTabExpanded[key] = false;
    }
  }

  state.layersTabExpanded[tabKey] = extend;
  state.layersTabExpanded = state.layersTabExpanded;
}

const getters = {
  centreWindowVisible(state) {
    return state.centreWindowVisible;
  },
  saveCompositionWindowVisible(state) {
    return state.saveCompositionWindowVisible;
  },
  apiErrorWindowVisible(state) {
    return state.apiErrorWindowVisible;
  },
  apiErrorMessage(state) {
    return state.apiErrorMessage;
  },
  migrationErrorWindowVisible(state) {
    return state.migrationErrorWindowVisible;
  },
  migrationErrorMessage(state) {
    return state.migrationErrorMessage;
  },
  getLayerFromFileWindowVisible(state) {
    return state.getLayerFromFileWindowVisible;
  },
  addLayerFromServiceWindowVisible(state) {
    return state.addLayerFromServiceWindowVisible;
  },
  showMapShortcutsWindowVisible(state) {
    return state.showMapShortcutsWindowVisible;
  },
  downloadTemplateWindowVisible(state) {
    return state.downloadTemplateWindowVisible;
  },
  notification(state) {
    return state.notification;
  },
  featuresTableColumnsWindowVisible(state) {
    return state.featuresTableColumnsWindowVisible;
  },
  featuresFilterWindowVisible(state) {
    return state.featuresFilterWindowVisible;
  },
  historyFilterWindowVisible(state) {
    return state.historyFilterWindowVisible;
  },
  historyDetailsWindowVisible(state) {
    return state.historyDetailsWindowVisible;
  },
  reportWizardWindowVisible(state) {
    return state.reportWizardWindowVisible;
  },
  exportToFileWindowVisible(state) {
    return state.exportToFileWindowVisible;
  },
  askForArchiveDataWindowVisible(state) {
    return state.askForArchiveDataWindowVisible;
  },
  zoomToOwnRangeWindowVisible(state) {
    return state.zoomToOwnRangeWindowVisible;
  },
  fieldsCalculatorWindowVisible(state) {
    return state.fieldsCalculatorWindowVisible;
  },
  attributesTab(state) {
    return state.featuresTableActiveTab === ATTRIBUTES_TAB;
  },
  historyTab(state) {
    return state.featuresTableActiveTab === HISTORY_TAB;
  },
  systemLayersExpanded(state) {
    return state.layersTabExpanded.system;
  },
  mvtLayersExpanded(state) {
    return state.layersTabExpanded.mvt;
  },
  pwidLayersExpanded(state) {
    return state.layersTabExpanded.pwid;
  },
  archiveLayersExpanded(state) {
    return state.layersTabExpanded.archive;
  },
  userLayersExpanded(state) {
    return state.layersTabExpanded.user;
  },
  compositionLayersExpanded(state) {
    return state.layersTabExpanded.composition;
  },
  backgroundLayersExpanded(state) {
    return state.layersTabExpanded.background;
  },
  reportDemandPopupVisible(state) {
    return state.reportDemandPopupVisible;
  },
  mapPermalinksVisible() {
    return state.mapPermalinksVisible;
  },
  reportDemandAddress(state) {
    return state.reportDemandPopupAddress;
  },
  demandFormVisible(state) {
    return state.demandFormVisible;
  },
  demandExportVisible(state) {
    return state.demandExportVisible;
  },
  demandForm(state) {
    return state.demandForm;
  },
  appliedSearchResultFilters(state) {
    return state.appliedSearchResultFilters;
  },
  searchResultFilterVisible(state) {
    return state.searchResultFilterVisible;
  },
  distinctColumnValues(state) {
    return state.distinctColumnValues;
  },
  closestObjectInfo(state) {
    return state.closestObjectInfo;
  },
  zoomMode(state) {
    return state.zoomMode;
  },

  objectDetailsWindowVisible(state) {
    return state.objectDetailsWindowVisible;
  }
};

export default {
  state,
  mutations,
  getters
};
